// extracted by mini-css-extract-plugin
export default {"caret":"NavItemDropdown_caret__u8OC2","open":"NavItemDropdown_open__nIB9t","close":"NavItemDropdown_close__U+44P","item":"NavItemDropdown_item__HSbWJ"};